import React from 'react';
import { Grid } from '@mui/material';
import { MigrationRequestModuleStore } from 'Administrator_Pages/MigrationRequests/MigrationRequestModuleStore';
import { InfoContainer, StyledPaper } from './styles';
import Button from 'Components/Button';
import { InformationTypes } from 'Administrator_Pages/MigrationRequests/enumerations/enums';

const HiFriendInformation = () => {
  const migrationStore = MigrationRequestModuleStore.Instance().Use();
  const infoStore = migrationStore.Information.Use();
  const destinationType = migrationStore.DestinationType;
  const data = infoStore.Info;

  const onClear = () => {
    infoStore.clear();
    migrationStore.ClearInformation();
  };

  if (destinationType !== InformationTypes.HIFRIEND || !data) {
    return <></>;
  }

  return (
    <Grid container item xs={7}>
      <StyledPaper elevation={2}>
        <InfoContainer container>
          <Grid item xs={6}>
            {data.groupId === 2003 ? 'Organization: HiFriend Youth' : 'Organization: HiFriend'}
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button onClick={onClear} variant={Button.variant.OUTLINED}>
              Clear
            </Button>
          </Grid>
        </InfoContainer>
      </StyledPaper>
    </Grid>
  );
};

export default HiFriendInformation;
